import React from 'react';
import { Helmet } from 'react-helmet';
import AboutUsHeroImage from '../../images/AboutUsPage/HH25_AboutUs_HeroBackground.png';
import AboutUsSection2Image from '../../images/HomePage/HH25_HeroSection4_BackgroundImage.png';
import FounderMicaImage from '../../images/AboutUsPage/HH25_AboutUs_Founders_Mica.png';
import FounderPaulaImage from '../../images/AboutUsPage/HH25_AboutUs_Founders_Pau.png';
import IconLeftArrow from '../../images/HowItWorksPage/HH25_HowItWorks_Section3_IconTipExtra.svg';
import LogoHH from '../../images/Logo/HH25_Logo_Blanco.png'
import Mision from '../../images/AboutUsPage/HH25_AboutUs_Mision.png'

const AboutUsPage = () => {
  return (
    <div className="about-us-page-container">
      <Helmet>
        <title>HappyHome - Nosotras</title>
        <meta name="description" content="" />
        <meta name="keywords" content="" />
        <meta property="og:title" content="HappyHome - Nosotras" />
        <meta property="og:description" content="" />
        <meta property="og:image" content={AboutUsHeroImage} />
        <meta property="og:url" content="http://www.happyhome.com.ar" />
      </Helmet>
      <div className="aboutus-hero-fullwidth">
        <div className="aboutus-hero-text-col">
          <h1 className="aboutus-hero-title">
            <span className="aboutus-hero-main">Conectar personas</span><br />
            <span className="aboutus-hero-mission">es nuestra <span className="italic">misión</span></span><br />
            <span className="aboutus-hero-purpose">Transformar <span className="italic">hogares</span>,<br />nuestro propósito.</span>
          </h1>
        </div>
        <div className="aboutus-hero-img-col" />
      </div>
      <div className="aboutus-section2" style={{ backgroundImage: `url(${AboutUsSection2Image})` }}>
        <div className="aboutus-section2-inner">
          <div className="aboutus-section2-top">
            Somos Paula y Micaela, y nos une una idea muy simple pero profunda
          </div>
          <div className="aboutus-section2-quote">
            “<b>QUE CONTRATAR SEA FÁCIL Y HUMANO, Y TRABAJAR<br />EN CASAS DE FAMILIA SEA UNA EXPERIENCIA DIGNA,<br />ACOMPAÑADA Y CON OPORTUNIDADES REALES DE CRECER.</b>”.
          </div>
          <div className="aboutus-section2-desc">
            <span className="aboutus-section2-hh">HAPPY HOME</span> NACE DESDE LA EXPERIENCIA REAL,<br />
            LA EMPATÍA Y LAS GANAS DE CAMBIAR UNA PARTE DEL SISTEMA<br />
            QUE MUCHAS VECES DEJA A LAS PERSONAS SIN OPCIONES.
          </div>
        </div>
      </div>
      <div className="aboutus-founders-section">
        <div className="aboutus-founder aboutus-founder-mica">
          <div className="aboutus-founder-text">
            <div className="aboutus-founder-title">
              Conocé <span className="aboutus-founder-name-mica">a Mica</span>
            </div>
            <div className="aboutus-founder-arrow-row">
              <img src={IconLeftArrow} alt="Flecha" className="aboutus-founder-arrow" />
              <div className="aboutus-founder-description">
                <span className="aboutus-founder-desc-bold">Diseñadora, especialista en comunicación.</span><br />
                Ama crear espacios que inviten al bienestar, que abracen y cuenten historias. Fuera del trabajo, la vas a encontrar caminando por la naturaleza, descubriendo nuevos sabores en la cocina o soñando con el próximo destino a explorar.<br /><br />
                Para ella, el hogar es mucho más que un lugar: es un refugio, una extensión de nuestra alma.<br /><br />
                Compartir la vida con Antonio, su perro y gran compañero, que llena de alegría cada rincón.<br />
                <span className="aboutus-founder-desc-highlight">Su deseo es transformar casas en hogares, con detalles que hagan sentir, recordar y sonreír.</span>
              </div>
            </div>
          </div>
          <div className="aboutus-founder-img-wrap">
            <img src={FounderMicaImage} alt="Mica fundadora" className="aboutus-founder-img" />
            <div className="aboutus-founder-img-bg aboutus-founder-img-bg-mica" />
          </div>
        </div>
        <div className="aboutus-founder aboutus-founder-pau">
          <div className="aboutus-founder-img-wrap">
            <img src={FounderPaulaImage} alt="Pau fundadora" className="aboutus-founder-img" />
          </div>
          <div className="aboutus-founder-text">
            <div className="aboutus-founder-title">
              Conocé <span className="aboutus-founder-name-pau">a Pau</span>
            </div>
            <div className="aboutus-founder-arrow-row">
              <img src={IconLeftArrow} alt="Flecha" className="aboutus-founder-arrow" />
              <div className="aboutus-founder-description">
                <span className="aboutus-founder-desc-bold">Economista, emprendedora y mamá.</span><br />
                Tiene una mente inquieta y el corazón puesto en el propósito.<br /><br />
                Antes de crear Happy Home, fundó otro emprendimiento que le dio la experiencia y la claridad para entender qué necesita un proyecto con alma y visión.<br /><br />
                Además de su formación en economía, se capacitó en constelaciones familiares, tarot y terapias holísticas. Tiene un profundo interés por la cocina natural, la nutrición consciente y los hogares libres de tóxicos.<br />
                <span className="aboutus-founder-desc-highlight">Apasionada, comprometida y creativa, su forma de pensar une lo estratégico y lo sensible. Y eso se nota en cada decisión que toma en Happy Home.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="aboutus-why-section">
        <div className="aboutus-why-inner">
          <h2 className="aboutus-why-title">
            ¿Por qué creamos <span className="aboutus-why-hh">Happy<span className="aboutus-why-hh-bold">Home</span><sup className="aboutus-why-reg">®</sup></span>?
          </h2>
          <div className="aboutus-why-desc-top">
            Porque lo vivimos en carne propia: buscar ayuda para<br />el hogar era difícil, y las opciones confiables inaccesibles.
          </div>
          <div className="aboutus-why-row">
            <img src={IconLeftArrow} alt="Flecha" className="aboutus-why-arrow" />
            <span className="aboutus-why-born">ASÍ NACIÓ</span>
            <img src={LogoHH} alt="Logo HappyHome" className="aboutus-why-logoimg" />
            <span className="aboutus-why-bridge">COMO PUENTE, COMO SOLUCIÓN, COMO COMUNIDAD.</span>
          </div>
          <div className="aboutus-why-desc-bottom">
            Queremos que cada persona tenga su espacio:<br />
            donde pueda mostrar quién es, cargar su experiencia, capacitarse<br />
            y sentirse acompañada en el camino..
          </div>
        </div>
      </div>
      <div className="aboutus-mission-section">
        <div className="aboutus-mission-inner">
          <div className="aboutus-mission-img-col">
            <img src={Mision} alt="Fundadoras HappyHome" className="aboutus-mission-img" />
          </div>
          <div className="aboutus-mission-content-col">
            <img src={LogoHH} alt="Logo HappyHome" className="aboutus-mission-logo" />
            <h2 className="aboutus-mission-title">Nuestra misión</h2>
            <div className="aboutus-mission-highlight">
              CREAR LA RED DE EMPLEO DOMÉSTICO Y OPERATIVO<br />
              MÁS GRANDE DE ARGENTINA, ACCESIBLE,<br />
              PROFESIONAL Y PROFUNDAMENTE HUMANA.
            </div>
            <div className="aboutus-mission-desc">
              Gracias por estar acá. Si llegaste hasta esta sección,<br />
              es porque buscás una solución que tenga corazón.<br />
              Y en Happy Home, eso es lo que intentamos<br />
              construir cada día.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUsPage;